import configTypeDef from './a8config'
import a8DataTypeDef from './a8data'
import a8soloUITypeDef from './a8soloUI'
import a8FlowTypeDef from './a8flow'
import a8FormsTypeDef from './a8forms'
import a8FuncTypeDef from './a8func'
import loggingTypeDef from './logging'
import serviceTypeDef from './service'
import a8SoloTypeDefs from './a8solo'
import a8AstroTypeDefs from './a8Astro'
import a8I18NTypeDefs from './a8I18N'
import a8GenTypeDefs from './a8gen'
import a8FormsV3TypeDef from './a8formsV3'
import { Scope } from './interface'
import { store } from '../../stateManager'

export const generateTypeDefs = (scope: Scope) => {
    const state = store.getState();
    const appType = state.apps.selectedApp.type;
    const globalDefs = `
        declare var moment: any;
        declare var _: any;

        interface URLTemplate {
            template: string,
            params: {
                [key: string]: any
            }
        }

        interface AxiosRequestConfig {
            url?: string;
            method?: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE' | 'get' | 'put' | 'patch' | 'post' | 'delete' | string;
            headers?: any;
            data?: any;
        }

        interface Options {
            url?: string;
            method?: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE' | 'get' | 'put' | 'patch' | 'post' | 'delete' | string;
            headers?: any;
            data?: any;
            urlTemplate?: URLTemplate;
        }

        type AxiosWrapper = {
            (config: Options): Promise<any>;
            (url: string, config?: Options): Promise<any>;
            post?:(url: string | URLTemplate, body?: any, options?: AxiosRequestConfig ) => Promise<any>;
            get?:(url: string | URLTemplate, options?: AxiosRequestConfig) => Promise<any>;
            put?:(url: string | URLTemplate, body?: any, options?: AxiosRequestConfig ) => Promise<any>;
            delete?:(url: string | URLTemplate, options?: AxiosRequestConfig) => Promise<any>;
        };

        declare var axios: AxiosWrapper;
    `
    const eventStreamDefs = `
        interface IPublishToTaskAssisted {
            processInstanceId: string;
            taskId: string;
            data: object | null;
        }
        interface IPublishToTaskSolo {
            sessionId: string;
            nodeId: string;
            data: object | null;
        }
        declare var eventStream: {
            publishToTask(request: ${appType === "a8flow" ? 'IPublishToTaskAssisted' : 'IPublishToTaskSolo'})=> Promise<any>;
        }
    `

    return `
        ${globalDefs}
        ${configTypeDef(scope)}
        ${a8DataTypeDef(scope)}
        ${loggingTypeDef(scope)}
        ${a8FlowTypeDef(scope)}
        ${a8soloUITypeDef(scope)}
        ${(scope === 'inline' || scope === 'functionClient' || scope === "solo") ? a8FormsTypeDef(scope) : ''}
        ${(scope === 'inline' || scope === 'functionClient' || scope === 'functionServer' || scope === "solo") ? a8FuncTypeDef(scope) : ''}
        ${(scope === 'service' || scope === 'solo') ? serviceTypeDef(scope) : ''}
        ${a8SoloTypeDefs(scope)}
        ${a8AstroTypeDefs(scope)}
        ${a8GenTypeDefs()}
        ${(scope === 'inline' || scope === 'functionClient' || scope === "solo") ? a8I18NTypeDefs(scope) : ''}
        ${(scope === 'functionServer' || scope === 'service') ? eventStreamDefs : ""}
        ${(scope === 'functionClient' && appType === "a8flow") && a8FormsV3TypeDef()}
    `
}